import { render, staticRenderFns } from "./MaterialsInfo.vue?vue&type=template&id=08be7192&scoped=true&"
import script from "./MaterialsInfo.vue?vue&type=script&lang=js&"
export * from "./MaterialsInfo.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsInfo.vue?vue&type=style&index=0&id=08be7192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be7192",
  null
  
)

export default component.exports